Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-delivery-availability', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-product-details-delivery-availability', $context),
            $content = $('.delivery-availability-wrapper', $control);

        if ($control.length < 1)
            return;

        var control = $control.get(0);
        var $resultsContainer = $('.results-container', $content);

        control.setDeliveryPointService;

        $content.on('keyup', 'input', function (e) {
            removeWhiteSpaces($(this));

            if (e.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();
                $('.js-submit', $content).trigger('click');
                return;
            }
        });      

        $content.on('click', '.js-submit', function (e) {

            e.preventDefault();
            e.stopPropagation();

            if ($(this).hasClass("disabled")) return;
            if ($content.hasClass('x-loading')) return;

            $content.addClass('x-loading');   

            control.skuId = $content.data("skuid");  
            control.quantity = $('.qty-spinner-input').val() || 1;
            control.postalCode = $('.js-search-term', $content).val();

            var variantArray = [];
            var variant = {
                VariantId: control.skuId,
                Quantity: control.quantity
            };
            variantArray.push(variant);

            Vendd.MessageBus.publishAsync(control, new Vendd.Product.Messages.GetDeliveryAvailability(variantArray, control.postalCode, null, true));
        });

        $('.js-show-delivery-availability', $control).fancybox({
            touch: false          
        });
      
        control.hideForm = function () {
            $('.js-delivery-availability-form', $content).hide();
            $('.form-msg .js-error', $content).show();
        };

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetDeliveryAvailabilitySuccess, control, function (envelope) {
            var data = envelope.message.data;

            //Set Delivery Availability Id
            var availability = data.DeliveryAvailabilities[0].Message;
            var availabilityId;
            if (data.DeliveryAvailabilities[0].MaxDays == null && data.DeliveryAvailabilities[0].MinDays == null) {
                availabilityId = 1;
            } else {
                availabilityId = 3;
            }

            //Show Delivery Availability
            $('.x-product-details .lazyload-availability-container > span').remove();
            $('.x-product-details .lazyload-availability-container').append('<span class="availability availability-' + availabilityId + ' icon-type-' + availabilityId + '">' + availability + '</span>');

            control.setDeliveryPointService = $.Deferred();

            //Function for setDeliveryPoint Service ajax call
            var deliveryPointId = 1;
            setDeliveryPoint(deliveryPointId);

            $.when(control.setDeliveryPointService)
                .done(function (setDeliveryPointResolve) {  
                    //Create cookie for Delivery Postal Code
                    if (control.postalCode)
                        Cookies.set('DeliveryPostalCode', control.postalCode, { expires: 1/24 });
                    //get model of delivery point
                    if ($('.x-deliverypoint-widget-a').length > 0) {
                        Vendd.MessageBus.publish($('.x-deliverypoint-widget-a'), new Vendd.DeliveryPoint.Messages.GetModel());
                    }
                    //close pop up
                    $.fancybox.close();
                    $content.removeClass('x-loading');
                });           
        });

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetAvailableWarehousesFailure, control, function (envelope) { });

        //setDeliveryPoint Service ajax call
        function setDeliveryPoint(deliveryPointId) {
            $.ajax({
                type: "post",
                url: "/Services/api/DeliveryPoint/SetDeliveryPoint",
                data: {
                    deliveryPointId: deliveryPointId
                },
                dataType: "json",
                statusCode: {
                    200: function (response) {
                        //Resolve
                        control.setDeliveryPointService.resolve(response);
                    },
                    404: function (response) {
                        control.setDeliveryPointService.reject();
                        console.log("error");
                    },
                    500: function (response) {
                        control.setDeliveryPointService.reject();
                        console.log("error");
                    }
                }
            });
        }

    });

});